module.exports = __webpack_public_path__ + "static/media/home-min.fbba0a40.png";